/*
	Use this module to load custom JS in the builder page
*/

(function () {
	"use strict";

}());


// WEBPACK FOOTER //
// ./assets/js/custom/builder.js